/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentHistoryFilter {
    getFixupPrototypeFunction() { return ComplianceAssessmentHistoryFilter.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentHistoryFilter>): ComplianceAssessmentHistoryFilter {
        let obj = Object.assign(new ComplianceAssessmentHistoryFilter(), model);
        ComplianceAssessmentHistoryFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentHistoryFilter>): ComplianceAssessmentHistoryFilter {
        if (!model) return null;
        return ComplianceAssessmentHistoryFilter.newInstance(<ComplianceAssessmentHistoryFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentHistoryFilter) {
        if (!obj) return;

        models.ComplianceAssessmentHistoryFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentHistoryFilter): boolean {
        Object.setPrototypeOf(obj, ComplianceAssessmentHistoryFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.query) {
            models.QueryOperator.fixupPrototype(this.query);
        }
    }

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Flag to get only latest standard assessment for service account
     */
    only_latest: boolean;

    /**
     * Search based on name
     */
    search: string;

    /**
     * Query based on service_account_ids and standard_ids
     */
    query: models.QueryOperator;

}
